import { useState, useEffect } from 'react';
import { isMobileOrTabletDevice } from '../utils/device';

/**
 * Custom hook that returns true if the current device/viewport is mobile or tablet ("taps"),
 * and false if it is a PC or laptop. Automatically updates on window resize or orientation change.
 *
 * @returns {boolean} isMobileOrTablet
 */
export function useIsMobileOrTablet() {
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(() => {
    if (typeof window === 'undefined') return false;
    return isMobileOrTabletDevice();
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(isMobileOrTabletDevice());
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return isMobileOrTablet;
}

export default useIsMobileOrTablet;
